import { cn } from "@win-reality/react-ui";

type MetricTileProps = {
  label: string;
  value: string | null;
  unit: string;
  onClick: () => void;
  "data-testid"?: string;
  valueTestId?: string;
  "data-metric"?: string;
};

export const MetricTile = ({
  label,
  value,
  unit,
  onClick,
  "data-testid": testId,
  valueTestId,
  "data-metric": metric,
}: MetricTileProps) => (
  <button
    type="button"
    data-testid={testId}
    data-metric={metric}
    onClick={onClick}
    aria-label={`Change ${label} tile`}
    className={cn(
      // Size
      "h-[88px] w-[88px]",
      // Layout
      "flex flex-col items-center justify-center gap-0.5",
      // Spacing
      "p-2",
      // Border
      "rounded-[5px] border border-transparent",
      // Background
      "bg-tagging-card dark:bg-white/[0.04]",
      // Text
      "text-center",
      // Effects
      "transition-colors",
      // States
      "hover:border-tagging-option-selected-border/50",
    )}
  >
    <span className="w-full truncate text-[11px] text-tagging-muted">
      {label}
    </span>
    <span
      data-testid={valueTestId}
      data-metric={metric}
      data-value={value ?? undefined}
      className="text-lg font-bold leading-tight text-gray-900 dark:text-white"
    >
      {value ?? "– –"}
    </span>
    <span className="w-full truncate text-[11px] text-tagging-muted">
      {unit}
    </span>
  </button>
);
